<form id="initOlvidoForm" novalidate autocomplete="off" class="cb-olvido-form" name="olvidoForm" action="{{ olvidoCtrl.data.url }}" method="POST">
	<input type="hidden" name="origen" value="{{ olvidoCtrl.data.origen }}">
	<span data-ng-transclude onclick="document.getElementById('initOlvidoForm').submit();"></span>
	<input type="hidden" name="idioma" id="initOlvidoFormIdioma" value="{{ olvidoCtrl.data.idioma }}">
</form>
